import axiosInstance from './AxiosInstance';

export const getWorkRegister = (params = {}) =>
  axiosInstance.get('/work-register', { params });

export const getWorkRegisterTeamMembers = () =>
  axiosInstance.get('/work-register/team-members');

export const tagCommentForWorkRegister = (payload) =>
  axiosInstance.post('/work-register/tag-comment', payload);

export const updateWorkRegisterEntryStatus = (entryId, status) =>
  axiosInstance.patch(`/work-register/entries/${entryId}/status`, { status });

export const updateWorkRegisterEntryRemarks = (entryId, remarks) =>
  axiosInstance.patch(`/work-register/entries/${entryId}/remarks`, { remarks });

export const postponeWorkRegisterEntry = (entryId, payload) =>
  axiosInstance.patch(`/work-register/entries/${entryId}/postpone`, payload);

export const updateWorkRegisterTaskRemarks = (taskId, payload, params = {}) =>
  axiosInstance.patch(`/work-register/tasks/${taskId}/remarks`, payload, { params });

export const updateWorkRegisterTaskStatus = (taskId, payload, params = {}) =>
  axiosInstance.patch(`/work-register/tasks/${taskId}/status`, payload, { params });
